module.exports = __webpack_public_path__ + "img/02.bcd0457f.png";